<template>
  <div class="select-card">
    <div class="select-card-top">
      <div>费用类型</div>
      <div style="flex: 1">
        <div class="select-card-bottom">
          <div class="select-card-bottom-left">
            <!-- 产品分类 -->
            <el-cascader
              collapse-tags
              v-model="selectClass"
              :options="costType_op"
              :props="{
                multiple: true,
                label: 'name',
                value: 'name',
                checkStrictly: true,
              }"
              placeholder="请选择费用类型"
              size="small"
              style="min-width: 120px"
              ref="cascader_type"
              @change="changeCostType"
            >
              <template #default="{ data }">
                <span>{{ data.name }}</span>
              </template>
            </el-cascader>
          </div>
          <div class="select-card-bottom-left" style="margin-left: 10px">
            <!-- 数据维度 -->
            <el-cascader
              collapse-tags
              v-model="select_data_tree"
              :options="data_tree"
              :props="{
                multiple: true,
                label: 'deptName',
                value: 'deptIdOrOaAccount',
                checkStrictly: true,
              }"
              placeholder="请选择组织架构"
              size="small"
              style="min-width: 120px"
              ref="cascader_jg"
              @change="change"
            >
              <template #default="{ data }">
                <span>{{ data.deptName }}</span>
              </template>
            </el-cascader>
          </div>
          <div class="select-card-bottom-left" style="margin-left: 20px">
            <el-button type="primary" size="mini" @click="querySelect_line()"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <ul class="tabs-con">
        <li
          v-for="(i, index) in tabs"
          :key="index"
          :class="tabsIndex == i.type ? 'li-active' : ''"
          @click="tabClick(index)"
        >
          {{ i.name }}
        </li>
      </ul>
    </div>

    <div class="select-card-bottom">
      <ChartLine2
        v-if="tabsIndex == 3 && isFlag"
        :id="3 + 'costType'"
        :tissueComparison="tissueComparison"
        :key="random"
      />
      <Bar
        v-if="tabsIndex == 2 && isFlag"
        :tissueComparison="tissueComparison"
        :id="2 + 'costType'"
        :key="random"
      />
      <LineView
        v-if="tabsIndex == 1 && isFlag"
        :tissueComparison="tissueComparison"
        :id="1 + 'costType'"
        :key="random"
      />
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import ChartLine2 from "./chart_line_2.vue";
import Bar from "./bar";
import LineView from "./lineview";
import get_jg_list from "@/utils/jg";
import { mapGetters } from "vuex";
export default {
  components: {
    ChartLine2,
    Bar,
    LineView,
  },
  props: ["chartType", "date"],
  computed: {
    // ...mapGetters(["incomeCompare_pro"]),
  },
  data() {
    return {
      random: 0,
      dateParam: {},
      doctorIds: [],
      doctors: [],
      cascaderProps: {
        multiple: true,
        label: "regionName",
        value: "regionCode",
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.lazyLoad,
      },
      tabs: [
        {
          name: "柱状图",
          type: 1,
        },
        {
          name: "分布图",
          type: 2,
        },
        {
          name: "趋势图",
          type: 3,
        },
      ],
      tabsIndex: 1,
      select_data_tree: [], // 选中的数据维度权限
      data_tree: [],
      selectClass: [], // 选中的费用类型
      isLoading: false,
      isFlag: "",
      costType_op: [],
      departSearchList: [],
      costTypeSearchList: [],
    };
  },
  created() {
    console.log(this.date);
    this.startTime = this.date.startTime;
    this.endTime = this.date.endTime;
    this.select_data_tree = [];
    this.selectClass = [];
    this.querySelect_line();
    this.getCostType();
    this.init();
  },
  methods: {
    //费用类型
    getCostType() {
      let url = "COST_GETALLCOSTTYPE";
      this.axios
        .get(url, "")
        .then((result) => {
          // console.log("查询返回", result);
          if (result.retCode == "200") {
            this.costType_op = result.data;
          } else {
           
            this.$message.error(result.msg);
          }
        })
        .catch(() => {
          this.isLoading = false;
          // this.$store.dispatch("app/setLoading", false);
        });
    },
    async init() {
      let { data_tree } = await get_jg_list.get_jg_list(2);
      this.data_tree = data_tree;
    },
    tabClick(val) {
      // console.log(val);
      this.tabsIndex = val + 1;
    },
    //费用类型
    changeCostType(val) {
      this.$nextTick(() => {
        let nodesObj = this.$refs["cascader_type"].getCheckedNodes();
        let typeOne = {
            costTypeNames: [],
            level: 1,
          },
          typeTwo = {
            costTypeNames: [],
            level: 2,
          };
        if (nodesObj.length > 0) {
          nodesObj.forEach((element, index) => {
            if (element.level == 1) {
              typeOne.costTypeNames.push(element.value);
            }
            if (element.level == 2) {
              typeTwo.costTypeNames.push(element.value);
            }
          });
        }
        this.costTypeSearchList = [typeOne, typeTwo];
      });
    },

    //组织架构选择
    change(val) {
      this.$nextTick(() => {
        let nodesObj = this.$refs["cascader_jg"].getCheckedNodes();
        let deptOne = {
            departCodes: [],
            level: 1,
          },
          deptTwo = {
            departCodes: [],
            level: 2,
          },
          deptThree = {
            departCodes: [],
            level: 3,
          },
          deptFour = {
            departCodes: [],
            level: 4,
          },
          deptFive = {
            departCodes: [],
            level: 5,
          };
        if (nodesObj.length > 0) {
          nodesObj.forEach((element, index) => {
            if (element.level == 1) {
              deptOne.departCodes.push(element.value);
            }
            if (element.level == 2) {
              deptTwo.departCodes.push(element.value);
            }
            if (element.level == 3) {
              deptThree.departCodes.push(element.value);
            }
            if (element.level == 4) {
              deptFour.departCodes.push(element.value);
            }
            if (element.level == 5) {
              deptFive.departCodes.push(element.value);
            }
          });
        }
        this.departSearchList = [
          deptOne,
          deptTwo,
          deptThree,
          deptFour,
          deptFive,
        ];
      });
    },
    // 根据日期判断是月的第几周

    // 查询数据
    querySelect_line() {
      //type:1 组织架构 2:产品线
      this.isLoading = true;
      // this.$store.dispatch("app/setLoading", true);
      let params = {},
        url = "COST_COSTTYPECOMPARE";

      this.departSearchList = this.departSearchList.filter((element, index) => {
        return element.departCodes.length > 0;
      });
      this.costTypeSearchList = this.costTypeSearchList.filter(
        (element, index) => {
          return element.costTypeNames.length > 0;
        }
      );
      params = {
        departSearchList: this.departSearchList,
        costTypeSearchList: this.costTypeSearchList,
        end: this.endTime,
        start: this.startTime,
        timeType: 3,
      };

      // 数据请求
      this.axios
        .post(url, params)
        .then((result) => {
          console.log("对比分析产品-查询返回", result);
          if (result.retCode == "200") {
            this.tissueComparison = result.data;
            this.isFlag = true;
          } else {
             this.tissueComparison = {};
            this.$message.error(result.msg);
          }
          this.random = Math.random();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    formatDate(number) {
      var date = new Date(number);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return YY + MM + DD;
    },
  },
};
</script>

<style>
@media (max-width: 1440px) {
  /* 小于1440 */
  .week-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .week-input2 {
    margin-right: 0 !important;
    margin-top: 10px;
  }
  .text-btn2 {
    margin-left: 8px !important;
  }
  .text-btn3 {
    margin-left: 8px !important;
    margin-right: 0px !important;
  }
  .select-day {
    margin-left: 12px !important;
  }
  .class-list {
    margin-left: 8px !important;
  }
}
</style>

<style scoped lang="scss">
.select-card {
  background: #ffffff;

  border-bottom-left-radius: none;
  border-bottom-right-radius: none;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  width: 100%;
  margin-top: 24px;
  box-shadow: 0px 4px 32px 0px rgba(64, 98, 117, 0.12);
  .select-card-top {
    color: #262626;
    font-weight: bold;
    font-size: 16px;
    padding: 13px 24px 13px 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .tabs-con {
      min-width: 100px;
      display: flex;
      flex-direction: row;
      li {
        flex: 1;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-left: 16px;
      }
      .li-active {
        color: #00b54b;
        border-bottom: 2px solid #00b54b;
        text-align: center;
         font-weight: 700;
      }
    }
    .question {
      width: 18px;
      height: 18px;
      margin-left: 5px;
    }
    .question:hover {
      cursor: pointer;
    }
  }
  .select-card-bottom {
    padding: 8px 24px 8px 24px;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    align-items: center;
    .select-card-bottom-left {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      .class-list {
        margin-left: 24px;
        width: 200px;
      }
    }
    .select-card-bottom-right {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>